/** PdfUtils.printCopyVerification / PDFTable 와 동기화 */
export const CERTIFIED_STAMP_COLOR = '#664AA0';
export const CERTIFIED_STAMP_COLUMN_WIDTH = '130pt';
export const CERTIFIED_STAMP_HEADER_FONT_SIZE = '12pt';
export const CERTIFIED_STAMP_BODY_FONT_SIZE = '7pt';
export const CERTIFIED_STAMP_CELL_PADDING = '2pt';
export const CERTIFIED_STAMP_LINE_WIDTH = '0.5px';
export const CERTIFIED_STAMP_BORDER = `${CERTIFIED_STAMP_LINE_WIDTH} solid ${CERTIFIED_STAMP_COLOR}`;
export const CERTIFIED_STAMP_HEADER_LABEL = '원본대조필 (인)';
export const CERTIFIED_STAMP_SIGN_MAX_WIDTH = '50pt';
export const CERTIFIED_STAMP_SIGN_OPACITY = 0.5;
export const CERTIFIED_STAMP_FONT_FAMILY = 'NanumGothic, "Nanum Gothic", "Malgun Gothic", sans-serif';

export const STAMP_LAYOUT_FULL = 'FULL';
export const STAMP_LAYOUT_COMPACT = 'COMPACT';

export const normalizeStampLayout = (value) => (
  value === STAMP_LAYOUT_COMPACT ? STAMP_LAYOUT_COMPACT : STAMP_LAYOUT_FULL
);

/** PdfUtils.printCopyVerification columnWidth */
export const STAMP_PDF_WIDTH_PT = 130;
/** PdfUtils 기본 양식 헤더 행 대략 높이 */
export const STAMP_PDF_HEADER_HEIGHT_PT = 20;
export const STAMP_PDF_HEADER_FONT_SIZE_PT = 12;
/** 간략 양식 헤더 폰트 — 원본대조필이 전부이므로 조금 크게 */
export const STAMP_PDF_COMPACT_HEADER_FONT_SIZE_PT = 14;
/** 간략 양식 높이 — 위아래 여백을 좌우(8pt)와 비슷하게 */
export const STAMP_PDF_COMPACT_HEIGHT_PT = 28;
/** 간략 양식 왼쪽 칸 좌우 여백 — 인쇄 시 글자 잘림 방지 */
export const STAMP_PDF_COMPACT_PAD_PT = 8;
/** 기본 양식(제공사·제출처·현장명 포함) 대략 높이 */
export const STAMP_PDF_FULL_HEIGHT_PT = 77;
/** 기본 양식 헤더 문자열 폭 근사 — (인) 중심 X */
export const STAMP_PDF_HEADER_LABEL_WIDTH_PT = 92;
/** 간략 양식 왼쪽 칸 문구(원 본 대 조 필) 폭 근사 @ 14pt */
export const STAMP_PDF_COMPACT_LABEL_TEXT_WIDTH_PT = 89;
/** 간략 양식 (인) 칸 — 높이와 같은 정사각형 */
export const STAMP_PDF_COMPACT_SIGN_COL_PT = STAMP_PDF_COMPACT_HEIGHT_PT;
export const STAMP_PDF_COMPACT_LABEL_COL_PT = (
  STAMP_PDF_COMPACT_LABEL_TEXT_WIDTH_PT + STAMP_PDF_COMPACT_PAD_PT * 2 + 4
);
/** 간략 양식 전체 폭: 원본대조필 칸 + (인) 정사각형 */
export const STAMP_PDF_COMPACT_WIDTH_PT = (
  STAMP_PDF_COMPACT_LABEL_COL_PT + STAMP_PDF_COMPACT_SIGN_COL_PT
);
/** 간략 양식 미리보기 문구 — PdfUtils NBSP 간격과 동일 */
export const CERTIFIED_STAMP_COMPACT_LABEL = '원\u00A0본\u00A0대\u00A0조\u00A0필';

export const stampPdfWidthPt = (layout) => (
  normalizeStampLayout(layout) === STAMP_LAYOUT_COMPACT
    ? STAMP_PDF_COMPACT_WIDTH_PT
    : STAMP_PDF_WIDTH_PT
);

export const stampPdfHeightPt = (layout) => (
  normalizeStampLayout(layout) === STAMP_LAYOUT_COMPACT
    ? STAMP_PDF_COMPACT_HEIGHT_PT
    : STAMP_PDF_FULL_HEIGHT_PT
);

export const stampPdfHeaderLabelWidthPt = (layout) => (
  normalizeStampLayout(layout) === STAMP_LAYOUT_COMPACT
    ? STAMP_PDF_COMPACT_LABEL_COL_PT
    : STAMP_PDF_HEADER_LABEL_WIDTH_PT
);

/** 인감 중심 X — 간략은 (인) 정사각형 중심 */
export const stampPdfSignCenterXPt = (layout) => {
  const width = stampPdfWidthPt(layout);
  if (normalizeStampLayout(layout) === STAMP_LAYOUT_COMPACT) {
    return width - STAMP_PDF_COMPACT_SIGN_COL_PT / 2;
  }
  return (width - STAMP_PDF_HEADER_LABEL_WIDTH_PT) / 2
    + STAMP_PDF_HEADER_LABEL_WIDTH_PT
    - 6;
};

/**
 * 메일전송·템플릿 수정 폼 표시.
 * 폭·본문은 입력 가독성용 확대, 헤더 높이는 PDF(≈20pt @ 130pt폭) 비율에 맞춤.
 */
export const STAMP_PRINT_TOGGLE_NONE = 'NONE';

export const stampPrintToggleValue = (signOption, stampLayout) => (
  signOption === 'NONE' ? STAMP_PRINT_TOGGLE_NONE : normalizeStampLayout(stampLayout)
);

export const CERTIFIED_STAMP_FORM_WIDTH = 280;
export const CERTIFIED_STAMP_FORM_SCALE = CERTIFIED_STAMP_FORM_WIDTH / 130;
/** PdfUtils 헤더 ≈20pt (STAMP_HEADER_HEIGHT_PT 와 동일) */
export const CERTIFIED_STAMP_FORM_HEADER_HEIGHT = Math.round(STAMP_PDF_HEADER_HEIGHT_PT * CERTIFIED_STAMP_FORM_SCALE);
export const CERTIFIED_STAMP_FORM_HEADER_FONT_SIZE = 20;
/** 간략 미리보기 — PDF pt와 1:1 (기본 양식만 입력용 확대) */
export const CERTIFIED_STAMP_FORM_COMPACT_HEIGHT = `${STAMP_PDF_COMPACT_HEIGHT_PT}pt`;
export const CERTIFIED_STAMP_FORM_COMPACT_FONT_SIZE = `${STAMP_PDF_COMPACT_HEADER_FONT_SIZE_PT}pt`;
export const CERTIFIED_STAMP_FORM_COMPACT_PAD = `${STAMP_PDF_COMPACT_PAD_PT}pt`;
export const CERTIFIED_STAMP_FORM_COMPACT_SIGN_MAX_WIDTH = CERTIFIED_STAMP_SIGN_MAX_WIDTH;
export const CERTIFIED_STAMP_FORM_BODY_FONT_SIZE = 14;
export const CERTIFIED_STAMP_FORM_CELL_PADDING = '6px';
export const CERTIFIED_STAMP_FORM_SIGN_MAX_WIDTH = 58;
/** 기본 양식 미리보기 슬롯 — 간략/인쇄안함에서도 이 높이를 유지 */
export const CERTIFIED_STAMP_FORM_SLOT_MIN_HEIGHT = 240;

export const formatSupplierLine = (supplierLabel, supplier) => (
  `${supplierLabel || '제공사'} : ${supplier || '정보없음'}`
);

export const formatRecipientLine = (recipient) => (
  `제출처 : ${recipient?.trim() || '정보없음'}`
);

export const formatSiteLine = (site) => (
  `현장명 : ${site?.trim() || '정보없음'}`
);
